import React from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";

import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import deepMap from "deep-map";
import {
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  LinearProgress,
  FormControlLabel,
  Tooltip
} from "@material-ui/core";

import SearchBar from "./SearchBar";
import JsonView from "./JsonView";

require("../json-inspector.css");

// get all keys in an array of objects. eg, [{a:1},{a:2,b:2},{c:3,a:3}] --> ['a','b','c']
const getAllKeys = arr => {
  const keys = [];

  arr.forEach(e => {
    keys.push(...Object.keys(e));
  });
  return [...new Set(keys)];
};
export default class JSONDisplayModal extends React.Component {
  static propTypes = {
    jsonModalDisplayLevels: PropTypes.number.isRequired,
    onChangeSearchText: PropTypes.func.isRequired,
    formJsonModalSearchText: PropTypes.string.isRequired,
    onFormJSONModalDetailsClose: PropTypes.func.isRequired,
    tabularized: PropTypes.isRequired,
    modalData: PropTypes.shape({
      form_name: PropTypes.string,
      submission_id: PropTypes.string
    }).isRequired,
    onJSONModalChangeDisplayLevels: PropTypes.func.isRequired,
    formDataJSON: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      form_data: PropTypes.object
    }).isRequired,
    jsonFormModalOpen: PropTypes.bool.isRequired,
    isFetchingFormDataJSON: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      isSpreadsheetTab: false
    };
  }

  render() {
    // A large dataset will take a long time (30 seconds?) to render. For these cases displaying a <textarea>
    const MAX_SAFE_DATA_SIZE = 300000;
    let dataClone = {};
    // water stage photo displays is binary data that displays with JSON and bogs down the page,
    // as well as interferes with searching, this hides data over 10,000 characters in length
    if (Object.keys(this.props.formDataJSON).length > 0)
      dataClone = deepMap(this.props.formDataJSON.form_data, d => {
        if (d) {
          return d.length > 10000 ? "hidden" : d;
        }
        return d;
      });
    const stringifiedData = JSON.stringify(dataClone, null, "\t");
    const usingTextArea = stringifiedData.length > MAX_SAFE_DATA_SIZE;

    const arraysFound = this.props.tabularized;
    const arrayOfTables = Object.entries(arraysFound).map(([key, arr]) => {
      const cols = getAllKeys(arr);
      const colsDef = [];
      colsDef.push({
        Header: "#",
        width: 50,
        accessor: "num",
        Cell: row => <div>{row.viewIndex + 1}</div>
      });

      colsDef.push(
        ...cols.map(col => ({
          Header: col,
          accessor: col,
          sortMethod: (a, b) => {
            if (typeof a === "string" && typeof b === "number") return 1;
            if (typeof a === "number" && typeof b === "string") return -1;

            if (a === b) {
              return a > b ? 1 : -1;
            }
            return a > b ? 1 : -1;
          }
        }))
      );

      return (
        <div>
          <h2>{key.replace(/_/g, " ")}</h2>
          <ReactTable
            data={arr}
            key={key}
            columns={colsDef}
            className="-striped -highlight"
            showPagination={false}
            defaultPageSize={arr.length}
          />
        </div>
      );
    });
    const { isSpreadsheetTab } = this.state;
    return (
      <Dialog
        fullWidth
        maxWidth={false}
        open={this.props.jsonFormModalOpen}
        scroll="body"
        onClose={this.props.onFormJSONModalDetailsClose}
      >
        <DialogTitle>
          {this.props.isFetchingFormDataJSON ? (
            "Loading Form Data.."
          ) : (
            <div style={{ margin: 0 }}>
              {`${this.props.modalData.form_name} - (${this.props.modalData.submission_id})`}
              <br />
              <Tooltip
                title={
                  arrayOfTables.length
                    ? "Switch between JSON and tables view"
                    : "No tables found for this submission."
                }
              >
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!arrayOfTables.length}
                      checked={isSpreadsheetTab}
                      onChange={() =>
                        this.setState({ isSpreadsheetTab: !isSpreadsheetTab })
                      }
                      value="checkedA"
                    />
                  }
                  label="Use table view"
                />
              </Tooltip>
              {!isSpreadsheetTab && (
                <SearchBar {...this.props} usingTextArea={usingTextArea} />
              )}
            </div>
          )}
        </DialogTitle>
        <DialogContent>
          {this.props.isFetchingFormDataJSON ? (
            <LinearProgress />
          ) : (
            <Row
              style={{
                height: !isSpreadsheetTab ? window.innerHeight : "inherit"
              }}
            >
              <Col xs={11}>
                {!isSpreadsheetTab ? (
                  <JsonView
                    {...this.props}
                    usingTextArea={usingTextArea}
                    dataClone={dataClone}
                    stringifiedData={stringifiedData}
                  />
                ) : (
                  <div>{arrayOfTables}</div>
                )}
              </Col>
            </Row>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              this.setState({ isSpreadsheetTab: false });
              this.props.onFormJSONModalDetailsClose();
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
